import { useMutation, useQueryClient } from "@tanstack/react-query";

import http from "../../../http";
import { GET_PAYMENT_ACCOUNTS, SAVE_PAYMENT_ACCOUNT } from "../../URL";
import { IAxisErrorResponse } from "../../../interfaces";

interface ISavePaymentAccount {
  accountName: string;
  paymentAccountTypeCode: string;
  paymentAccountTypeCodeId: string;
}

const savePaymentAccount = async (fields: ISavePaymentAccount) => {
  await http.post(SAVE_PAYMENT_ACCOUNT, {
    ...fields,
  });
};

const useSavePaymentAccount = () => {
  const queryClient = useQueryClient();  // PR 7831723 

  return useMutation<void, IAxisErrorResponse, ISavePaymentAccount>({
    mutationKey: ["save-payment-account"],
    mutationFn: savePaymentAccount,
    // PR 7831723 Start
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["payment-accounts"] });
      queryClient.invalidateQueries({
        queryKey: ["grid", GET_PAYMENT_ACCOUNTS],
      });
    },
    // PR 7831723 End
  });
};

export default useSavePaymentAccount;
